<div id="wrapper">
  <div class="allcont">
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    <div class="border-type">
      <app-tab-nav (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
                   (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
                   (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
                   (updateInitializeData)="this.initializeData()">
      </app-tab-nav>
    </div>
    <div id="claro-logo">
      <div class="clBox">
        <img src='../../assets/images/miclaro-logo.png' class="cLogo">
      </div>
    </div>
    <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
    <div class="basicrow m-top" [hidden]="this.prepago==false">
      <div class="container">
        <div class="basicr-line-i">
          <div class="fulltitle f-btitle autodef title">
            <span class="icon-dash-14"></span> Resumen de Cuenta
          </div>
          <div class="pull-right spacing-account">
            <label class="label-r sidenmbr vcenter w-auto">
              <span class="tabcell">
                N&uacute;mero de Suscriptor
              </span>
            </label>
            <div class="autorow subsc mob-wid pull-right">
              <div *ngIf="this.totalAccountList> 0">
                <select [(ngModel)]="this.subscriber" (change)="this.refreshDataTo($event)" class="sel-f">
                  <option *ngFor="let list of this.subscribers" [ngValue]="list.subscriberNumberField">
                    {{list.subscriberNumberField}}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow m-top-ii" [hidden]="this.prepago==false">
      <div class="basicrow mbott m-top">
        <div class="container">
          <div class="basicrow m">
            <div>
              <div id="pintableDiv" class="basicrow allpads bordsdef text-justify mob-txt-a">
                <div class="basicrow msidespad m-top-u-i">
                  <div class="balancesptr-ii fortimes-a text-center">
                    <span class="roboto-b">
                      MI CLARO WALLET
                    </span><br/>
                    <span class="f-red f-lsemi roboto-b seph">
                      {{this.ewalletbalance | currency}}
                    </span>
                  </div>
                  <div class="balancesptr-ii fortimes-a h-nobrd-i text-center">
                    <span class="roboto-b">
                      BALANCE-PREPAGO
                    </span><br/>
                    <span class="f-red f-lsemi roboto-b seph">
                      {{this.balanceP|currency}}
                    </span>
                  </div>
                  <div class="balancesptr-ii-b fortimes-a text-center">
                    <span class="roboto-b">
                      ULTIMA RECARGA
                    </span><br/>
                    <div *ngIf="this.lastPrepaidReplenishment!=''">
                      <span class="f-red f-lsemi roboto-b seph">
                        {{this.lastPrepaidReplenishment}}
                      </span>
                    </div>
                    <div class="spacing-account" *ngIf="this.lastPrepaidReplenishment==''">
                      <span class="f-red f-lsemi roboto-b seph">

                      </span>
                    </div>
                    <div class="text-right mbott"
                         *ngIf="this.rechargedate!='' && this.rechargedate!=null && this.rechargedate!='Invalid Date'">
                      Fecha: {{this.rechargedate | date: 'MM/dd/yyyy'}}</div>
                    <div class="text-right mbott" *ngIf="this.rechargedate=='' || this.rechargedate==null">Fecha: N/A
                    </div>
                  </div>
                </div>
                <div class="logline full spacing-line"></div>
                <div class="autorow pull-left factdef roboto-b f-big">Servicios en Cuentas</div>
                <div class="logline full espacing"></div>
                <div class="account-services-box">
                  <div class="container-grid">
                    <div class="box-content">
                      <div class="box-content-1">
                        <div class="title-descr">
                          Detalle del Plan
                        </div>
                        <div class="des-plan" *ngIf="this.descrplaninfo!=''">
                          <ul>
                            <li>
                              {{this.planType}}
                              <div class="rate-movil">
                                <ul>
                                  <li>
                                    {{this.rateplaninfo|currency}}
                                  </li>
                                </ul>
                              </div>
                              <span class="rate-default">{{this.rateplaninfo|currency}}</span>
                            </li>
                          </ul>
                        </div>
                        <div class="des-plan" *ngIf="this.descrplaninfo==''">
                          <ul>
                            <li>
                              N/A
                              <div class="rate-movil">
                                <ul>
                                  <li>
                                    {{this.rateplaninfo|currency}}
                                  </li>
                                </ul>
                              </div>
                              <span class="rate-default">{{this.rateplaninfo|currency}}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="box-content-2">
                        <div class="title-descr">
                          Descripción del Plan:
                        </div>
                        <div *ngIf="this.descrplaninfo!=''">
                          <!--                          <ul class="list-features">-->
                          <!--                            <li *ngFor="let features of this.planFeatures; let i=index">-->
                          <!--                              {{features}}-->
                          <!--                            </li>-->
                          <!--                          </ul>-->
                          <div [innerHTML]="planDesc"></div>
                        </div>
                        <span *ngIf="this.descrplaninfo==''">
                          N/A
                        </span>
                      </div>
                    </div>
                    <div class="box-content">
                      <div class="box-content-1">
                        <div class="title-descr">
                          Recarga
                        </div>
                        <div class="des-plan">
                          <ul>
                            <li>
                              Última recarga:
                              <div class="rate-movil">
                                <ul>
                                  <li>
                                    {{this.lastPrepaidReplenishment}}
                                  </li>
                                </ul>
                              </div>
                              <span class="rate-default">{{this.lastPrepaidReplenishment}}</span>
                            </li>
                          </ul>
                        </div>
                        <div class="des-plan">
                          <ul>
                            <li>
                              Proxima recarga:
                              <div class="rate-movil">
                                <ul>
                                  <li>
                                    {{this.endDate}}
                                  </li>
                                </ul>
                              </div>
                              <span class="rate-default">{{this.endDate}}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="box-content-2">
                        <div class="title-warning">
                          *AVISO:
                        </div>
                        <div class="description-warning">
                          Para evitar la suspensión del servicio, su pago debe ser en
                          recibido en o antes de la fecha de su próxima recarga.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="logline full espacing"></div>
                <div class="container-monthly-rent">
                  <div class="monthly-rent-title">
                    Renta mensual
                  </div>
                  <div class="f-red f-lsemi roboto-b spacing-links2">
                    {{this.rateplaninfo|currency}}
                  </div>
                  <div class="btn-rent">
                    <a class="btns red def-i pull-right vcenter espacing btnr" (click)="this.goToRecharge();">
                      <span class="tabcell">
                        Recargar Ahora&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              <div class="box-prepaidbill">
                <div class="grid-prepaidbill">
                  <div class="box-img" (click)="goTransacciones()">
                    <div>
                      <img class="img-prepaidbill" src="../../assets/images/ico_historicospago_prepago.png">
                      <div style="padding-top: 10px; font-weight: 500;">Histórico de Transacciones</div>
                    </div>
                  </div>
                  <div class="box-img" (click)="this.printBill('claro-logo','pintableDiv');">
                    <div>
                      <img class="img-prepaidbill" src="../../assets/images/ico_print_prepago.png">
                      <div style="padding-top: 10px; font-weight: 500;">Imprimir Resumen de Cuenta</div>
                    </div>
                  </div>
                  <div class="box-img" (click)="this.goAtenttionCenter()">
                    <div>
                      <img class="img-prepaidbill" src="../../assets/images/ico_ubicacion_prepago.png">
                      <div style="padding-top: 10px; font-weight: 500;">Centros de Atención</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="logline full espacing"></div>
              <div class="btns-grid">
                <div class="btns-content">
                  <a class="btns blue vcenter" (click)="this.goToRecharge();">
                    <span class="tabcell">
                      Metodos de Recargar <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                  </a>
                </div>
                <div class="btns-content">
                  <a class="btns blue vcenter" (click)="this.goToRecharge();">
                    <span class="tabcell">
                      Recargar en Tiendas <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
